import { buildAxiosErrorMessage } from '@/utils/buildAxiosErrorMessage'
import * as Sentry from '@sentry/react'
import axios from 'axios'
import { setupAuthInterceptor } from './axios.interceptors'

export const axiosLutien = axios.create({
  timeout: 20000,
  baseURL: import.meta.env.VITE_URL_LUTIEN_API,
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json'
  }
})

// Setup auth interceptor
setupAuthInterceptor(axiosLutien)

// Error handling interceptor
axiosLutien.interceptors.response.use(undefined, error => {
  const errorMessage = buildAxiosErrorMessage(error, 'Lutien Error')
  console.error(errorMessage)

  if (error?.config?.url === '/api/v1/auth/login') {
    return Promise.reject(error)
  }

  Sentry.captureException(errorMessage)
  return Promise.reject(error)
})
